export const API_KEY = 'AIzaSyCM_vtZnllHyqUkJVCx7Eh-GstJEBAC0qQ'
// export const API_KEY = 'AIzaSyCC7xpd2-tn00vGU538XyvwEWk5gCyR5fo'

export default API_KEY